<app-dialog-header [title]="'GENERAL.PROPERTY.PREVIEW'" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="h-full bg-zinc-50" fxLayout="row" fxLayoutAlign="start stretch" *ngIf="courseCatalogLandingPageOverview">
    <app-catalog-sidebar
        class="w-full max-w-80"
        [categories]="courseCatalogLandingPageOverview.categories"
        (categorySelected)="openCourseStructureCategory($event)"
        (rootClicked)="showCourseCatalogLandingPageOverview()"
        [navigateOnClick]="false"
    ></app-catalog-sidebar>

    <div class="page-container w-full overflow-y-auto p-24">
        <div class="bg-white overflow-x-hidden pt-32" *ngIf="!selectedCourseStructureCategoryId; else previewMode">
            <h2 class="mt-0 mb-24 font-semibold text-3xl sm:text-4xl px-32">
                {{ courseCatalogLandingPageOverview.title }}
            </h2>

            <div class="w-full pb-148" *ngIf="courseCatalogLandingPageOverview.categories?.length">
                <ng-container *ngFor="let categorySection of courseCatalogLandingPageOverview.categories">
                    <ng-container *ngIf="categorySection.postingStream?.length">
                        <div class="mb-24 mt-48 px-32" fxLayout="row" fxLayoutAlign="space-between">
                            <h2 class="font-semibold my-0 text-lg">{{ categorySection.name }}</h2>
                            <app-white-button [label]="'GENERAL.BUTTON.DISCOVER_MORE'" [disabled]="true"></app-white-button>
                        </div>
                        <app-catalog-postings-swipper [isInsideDialog]="true" [featuredWidget]="categorySection.postingStream"> </app-catalog-postings-swipper>
                    </ng-container>
                </ng-container>
            </div>
        </div>

        <ng-template #previewMode>
            <app-course-catalog class="w-full" [courseStructureCategoryId]="selectedCourseStructureCategoryId" [isInsideDialog]="true"></app-course-catalog>
        </ng-template>
    </div>
</div>
